import { getMetaClickIds } from "./metaParamBuilder";

function hashString(value) {
  let hash = 0;
  const text = String(value || "");

  for (let index = 0; index < text.length; index += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(index);
    hash |= 0;
  }

  return Math.abs(hash).toString(36);
}

function decodeCookieValue(value) {
  try {
    return decodeURIComponent(value || "");
  } catch {
    return value || "";
  }
}

export function getClientSignals() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      timezone: "",
      screenResolution: "",
      acceptLanguage: "",
      fingerprintId: "",
      fbc: "",
      fbp: "",
      eventSourceUrl: "",
    };
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const screenResolution = `${window.screen?.width || 0}x${window.screen?.height || 0}`;
  const acceptLanguage = navigator.language || navigator.languages?.[0] || "";
  const platform = navigator.platform || "";
  const colorDepth = window.screen?.colorDepth || "";
  const devicePixelRatio = window.devicePixelRatio || "";
  const hardwareConcurrency = navigator.hardwareConcurrency || "";
  const maxTouchPoints = navigator.maxTouchPoints || "";

  const fingerprintSource = [
    timezone,
    screenResolution,
    acceptLanguage,
    platform,
    colorDepth,
    devicePixelRatio,
    hardwareConcurrency,
    maxTouchPoints,
  ].join("|");

  const cookies = Object.fromEntries(
    document.cookie
      .split(";")
      .map((part) => part.trim().split(/=(.*)/s))
      .filter(([key]) => key)
      .map(([key, value]) => [key, decodeCookieValue(value)])
  );
  const metaIds = getMetaClickIds() || {};

  return {
    timezone,
    screenResolution,
    acceptLanguage,
    fingerprintId: `ft-${hashString(fingerprintSource)}`,
    fbc: metaIds.fbc || cookies._fbc || "",
    fbp: metaIds.fbp || cookies._fbp || "",
    eventSourceUrl: window.location.href,
  };
}

export function getClientSignalHeaders() {
  const signals = getClientSignals();

  return {
    "X-Client-Timezone": signals.timezone,
    "X-Client-Screen-Resolution": signals.screenResolution,
    "X-Client-Fingerprint": signals.fingerprintId,
  };
}
